export function compactText(text, max = 20) {
  if (text && text.length > max) {
    text = text.slice(0, max).concat('...');
  }

  return text;
}
